import { BRAND_COLORS } from "@/lib/brandColors";
import { Platform, StyleSheet } from "react-native";

/** Auth screens — re-export brand palette for convenience */
export const AUTH_COLORS = {
  ...BRAND_COLORS,
  inputBg: BRAND_COLORS.cardBg,
} as const;

const CARD_MAX_WIDTH = 440;

export const authScreenStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AUTH_COLORS.pageBg,
  },
  scrollContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  card: {
    backgroundColor: AUTH_COLORS.cardBg,
    borderRadius: 16,
    padding: 24,
    width: "100%",
    maxWidth: CARD_MAX_WIDTH,
    ...(Platform.OS === "web"
      ? {
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
        }
      : {
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.08,
          shadowRadius: 12,
          elevation: 4,
        }),
  },
  title: {
    fontSize: 28,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 8,
    color: AUTH_COLORS.text,
  },
  subtitle: {
    fontSize: 15,
    textAlign: "center",
    marginBottom: 28,
    color: AUTH_COLORS.muted,
    lineHeight: 22,
  },
  errorContainer: {
    backgroundColor: AUTH_COLORS.errorBg,
    borderLeftWidth: 4,
    borderLeftColor: AUTH_COLORS.error,
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
  },
  errorText: {
    color: AUTH_COLORS.error,
    fontSize: 14,
    lineHeight: 20,
  },
  form: {
    gap: 16,
  },
  row: {
    flexDirection: "row",
    gap: 12,
  },
  inputContainer: {
    gap: 8,
  },
  halfWidth: {
    flex: 1,
  },
  label: {
    fontSize: 14,
    fontWeight: "600",
    color: AUTH_COLORS.text,
  },
  input: {
    backgroundColor: AUTH_COLORS.inputBg,
    borderWidth: 1,
    borderColor: AUTH_COLORS.border,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
    fontSize: 16,
    color: AUTH_COLORS.text,
  },
  passwordField: {
    position: "relative",
    justifyContent: "center",
  },
  passwordInput: {
    paddingRight: 48,
  },
  passwordToggle: {
    position: "absolute",
    right: 12,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 4,
  },
  link: {
    color: AUTH_COLORS.accent,
    fontSize: 14,
    fontWeight: "600",
  },
  linkMuted: {
    color: AUTH_COLORS.muted,
    fontSize: 14,
  },
  forgotPassword: {
    alignSelf: "flex-end",
    marginTop: -8,
  },
  button: {
    borderRadius: 30,
    paddingVertical: 14,
    paddingHorizontal: 24,
    alignItems: "center",
    justifyContent: "center",
    minHeight: 48,
  },
  primaryButton: {
    backgroundColor: AUTH_COLORS.accent,
    marginTop: 8,
  },
  buttonText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "600",
  },
  googleButton: {
    backgroundColor: AUTH_COLORS.cardBg,
    borderWidth: 1,
    borderColor: AUTH_COLORS.border,
  },
  googleButtonText: {
    color: AUTH_COLORS.text,
    fontSize: 16,
    fontWeight: "500",
  },
  divider: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: AUTH_COLORS.border,
  },
  dividerText: {
    marginHorizontal: 16,
    color: AUTH_COLORS.muted,
    fontSize: 14,
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 16,
    flexWrap: "wrap",
  },
});
